// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6301) return "static/chunks/6301-c57873962307de1b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"472":"a453d5b94f60eb15","9341":"2549d410f930ad26"}[chunkId] + ".js";
};